import React from 'react';
import { Box, Flex, Text } from 'core/components';
import { Classes, Icon } from '@blueprintjs/core';
import { Label } from 'app/components/labels/Label';

export default (option) => {
  const {
    bg,
    className,
    focused,
    handleOptionRef,
    isCollapsed,
    isGroupHeader,
    isPreset,
    label,
    onToggleGroup,
    selected,
    selectItem,
    key,
    value
  } = option;

  if (isGroupHeader === true) {
    return (
      <Flex
        key={key || value}
        className={className}
        alignItems="center"
        justifyContent="space-between"
        onClick={(e) => {
          e.stopPropagation();
          if (onToggleGroup) {
            onToggleGroup(value);
          }
        }}
      >
        <Text ellipsis muted small width="100%">
          {label}
        </Text>
        <Icon icon={isCollapsed ? 'chevron-right' : 'chevron-down'} />
      </Flex>
    );
  }

  const ariaProps = {};
  if (selected) {
    ariaProps['aria-selected'] = selected;
  }

  return (
    <Box
      pt="4px"
      pb="4px"
      onClick={() => selectItem(value)}
      key={key || value}
      className={className}
      {...ariaProps}
      tabIndex={focused && handleOptionRef ? '0' : undefined}
      ref={focused && handleOptionRef}
      css={{
        [`&.${Classes.ACTIVE} .${Classes.TEXT_MUTED}`]: { color: 'inherit' },
        [`&:hover .${Classes.TEXT_MUTED}`]: { color: 'inherit' }
      }}
    >
      <Label name={label} bg={bg} isPreset={isPreset} />
    </Box>
  );
};
